import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Send, ChevronLeft, Info, Heart, Clock, Shield, Lock } from 'lucide-react';
import Header from '../components/Header';
const MatchView = () => {
  const [message, setMessage] = useState('');
  // Check if today is Friday
  const today = new Date();
  const isFriday = today.getDay() === 5;
  const [messages, setMessages] = useState([{
    id: 1,
    sender: 'match',
    content: "Assalamu alaikum! It's nice to connect with you through this app.",
    time: '2:30 PM'
  }, {
    id: 2,
    sender: 'user',
    content: "Walaikum assalam! Yes, I'm glad we matched. Tell me a bit about yourself?",
    time: '2:32 PM'
  }, {
    id: 3,
    sender: 'match',
    content: "I'm Sarah, 28 years old. I work in marketing for a local company and I'm passionate about art and culture. I have a Master's degree in Business Administration. How about you?",
    time: '2:35 PM'
  }]);
  const handleSendMessage = () => {
    if (message.trim() === '' || !isFriday) return;
    const newMessage = {
      id: messages.length + 1,
      sender: 'user',
      content: message,
      time: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setMessages([...messages, newMessage]);
    setMessage('');
    // Simulate reply after a short delay
    setTimeout(() => {
      const replyMessage = {
        id: messages.length + 2,
        sender: 'match',
        content: "That's interesting! I also enjoy traveling and exploring new cultures. What kind of places have you visited?",
        time: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      };
      setMessages(prev => [...prev, replyMessage]);
    }, 3000);
  };
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-700">
      <Header data-id="element-701" />
      <main className="flex-grow py-6 px-4" data-id="element-702">
        <div className="max-w-4xl mx-auto" data-id="element-703">
          <div className="mb-6" data-id="element-704">
            <Link to="/dashboard" className="flex items-center text-emerald-700 hover:text-emerald-800 transition duration-300" data-id="element-705">
              <ChevronLeft className="h-5 w-5 mr-1" data-id="element-706" />
              Back to Dashboard
            </Link>
          </div>
          {/* Chat Interface */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-707">
            {/* Chat Header */}
            <div className="bg-emerald-700 text-white p-4" data-id="element-708">
              <div className="flex items-center justify-between" data-id="element-709">
                <div className="flex items-center" data-id="element-710">
                  <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mr-3" data-id="element-711">
                    <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1961&auto=format&fit=crop" alt="Sarah's profile" className="w-10 h-10 rounded-full object-cover" data-id="element-712" />
                  </div>
                  <div data-id="element-713">
                    <h2 className="font-bold" data-id="element-714">Sarah, 28</h2>
                    <div className="flex items-center" data-id="element-715">
                      <span className="text-xs bg-emerald-600 px-2 py-0.5 rounded-full" data-id="element-716">
                        Verified Emirati
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-3" data-id="element-717">
                  {isFriday ? <div className="flex flex-col items-center bg-emerald-600 px-3 py-1 rounded-lg" data-id="element-718">
                      <Clock className="h-4 w-4" data-id="element-719" />
                      <span className="text-xs mt-1" data-id="element-720">Chat Open</span>
                    </div> : <div className="flex flex-col items-center bg-amber-600 px-3 py-1 rounded-lg" data-id="element-721">
                      <Lock className="h-4 w-4" data-id="element-722" />
                      <span className="text-xs mt-1" data-id="element-723">Chat Locked</span>
                    </div>}
                </div>
              </div>
            </div>
            {/* Guidelines Banner */}
            {isFriday ? <div className="bg-amber-50 p-3 border-b border-amber-100" data-id="element-724">
                <div className="flex items-center text-amber-800" data-id="element-725">
                  <Info className="h-5 w-5 text-amber-600 mr-2" data-id="element-726" />
                  <p className="text-sm" data-id="element-727">
                    Remember to be respectful and maintain Islamic etiquette.
                    Today is your only day to chat before the reflection period
                    begins.
                  </p>
                </div>
              </div> : <div className="bg-gray-100 p-4 border-b border-gray-200" data-id="element-728">
                <div className="flex items-center text-gray-700" data-id="element-729">
                  <Lock className="h-5 w-5 text-gray-500 mr-2" data-id="element-730" />
                  <div data-id="element-731">
                    <p className="text-sm font-medium" data-id="element-732">
                      Reflection Period Active
                    </p>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-733">
                      Review your Friday conversation below. You can send a
                      Khitbah request or decline the match by Thursday.
                    </p>
                  </div>
                </div>
              </div>}
            {/* Chat Messages */}
            <div className="p-4 h-96 overflow-y-auto bg-gray-50" data-id="element-734">
              <div className="space-y-4" data-id="element-735">
                {messages.map(msg => <div key={msg.id} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-736">
                    <div className={`max-w-xs md:max-w-md rounded-lg p-3 ${msg.sender === 'user' ? 'bg-emerald-100 text-emerald-900' : 'bg-white border border-gray-200 text-gray-800'}`} data-id="element-737">
                      <p className="text-sm" data-id="element-738">{msg.content}</p>
                      <p className={`text-xs mt-1 ${msg.sender === 'user' ? 'text-emerald-700' : 'text-gray-500'}`} data-id="element-739">
                        {msg.time}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
            {/* Message Input */}
            <div className="p-4 border-t border-gray-200" data-id="element-740">
              {isFriday ? <>
                  <div className="flex items-center" data-id="element-741">
                    <input type="text" value={message} onChange={e => setMessage(e.target.value)} placeholder="Type your message..." className="flex-grow px-4 py-2 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-emerald-500" onKeyPress={e => e.key === 'Enter' && handleSendMessage()} data-id="element-742" />
                    <button onClick={handleSendMessage} className="bg-emerald-700 hover:bg-emerald-800 text-white px-4 py-2 rounded-r-lg transition duration-300" data-id="element-743">
                      <Send className="h-5 w-5" data-id="element-744" />
                    </button>
                  </div>
                  <div className="mt-3 flex justify-between items-center" data-id="element-745">
                    <div className="flex items-center text-gray-500 text-sm" data-id="element-746">
                      <Shield className="h-4 w-4 mr-1" data-id="element-747" />
                      <span data-id="element-748">Messages are monitored for safety</span>
                    </div>
                    <div className="flex items-center text-amber-600 text-sm" data-id="element-749">
                      <Clock className="h-4 w-4 mr-1" data-id="element-750" />
                      <span data-id="element-751">Chat closes at midnight</span>
                    </div>
                  </div>
                </> : <div className="bg-gray-100 rounded-lg p-4" data-id="element-752">
                  <div className="flex items-center justify-center text-gray-600" data-id="element-753">
                    <Lock className="h-5 w-5 mr-2" data-id="element-754" />
                    <p className="text-sm" data-id="element-755">
                      Chat is locked during the reflection period. You can
                      review your conversation above and make your decision.
                    </p>
                  </div>
                </div>}
            </div>
          </div>
          {/* Decision Panel for Reflection Period */}
          {!isFriday && <div className="mt-8 bg-white rounded-xl shadow-md overflow-hidden" data-id="element-756">
              <div className="p-6" data-id="element-757">
                <h3 className="text-lg font-bold text-emerald-900 mb-4" data-id="element-758">
                  Make Your Decision
                </h3>
                <div className="bg-amber-50 p-4 rounded-lg mb-6" data-id="element-759">
                  <p className="text-amber-800 text-sm" data-id="element-760">
                    You have until Thursday to decide whether to proceed with a
                    Khitbah request or decline this match. Take your time to
                    reflect on your conversation and consider if this is the
                    right path forward.
                  </p>
                </div>
                <div className="flex space-x-4" data-id="element-761">
                  <button className="flex-1 bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-762">
                    <Heart className="h-5 w-5 mr-2" data-id="element-763" />
                    Send Khitbah Request
                  </button>
                  <button className="flex-1 border-2 border-gray-300 hover:bg-gray-100 text-gray-700 font-medium py-3 px-6 rounded-lg transition duration-300" data-id="element-764">
                    Decline Match
                  </button>
                </div>
              </div>
            </div>}
          {/* Conversation Guide */}
          {isFriday && <div className="mt-8 bg-white rounded-xl shadow-md overflow-hidden" data-id="element-765">
              <div className="p-6" data-id="element-766">
                <h3 className="text-lg font-bold text-emerald-900 mb-4" data-id="element-767">
                  Conversation Guide
                </h3>
                <div className="space-y-4" data-id="element-768">
                  <div className="bg-amber-50 p-4 rounded-lg" data-id="element-769">
                    <h4 className="font-medium text-amber-800 mb-2" data-id="element-770">
                      Suggested Topics
                    </h4>
                    <ul className="space-y-2 text-gray-700" data-id="element-771">
                      <li data-id="element-772">• Education and career aspirations</li>
                      <li data-id="element-773">• Family values and expectations</li>
                      <li data-id="element-774">• Religious outlook and practices</li>
                      <li data-id="element-775">• Hobbies and interests</li>
                      <li data-id="element-776">• Future goals and vision</li>
                    </ul>
                  </div>
                  <div className="bg-emerald-50 p-4 rounded-lg" data-id="element-777">
                    <h4 className="font-medium text-emerald-800 mb-2" data-id="element-778">
                      Etiquette Reminders
                    </h4>
                    <ul className="space-y-2 text-gray-700" data-id="element-779">
                      <li data-id="element-780">• Be respectful and honest in your communication</li>
                      <li data-id="element-781">
                        • Avoid asking for personal contact information too
                        early
                      </li>
                      <li data-id="element-782">
                        • Focus on values and compatibility rather than
                        appearance
                      </li>
                      <li data-id="element-783">
                        • Remember the purpose is marriage, not casual
                        conversation
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mt-6 text-center" data-id="element-784">
                  <button className="text-emerald-700 font-medium hover:text-emerald-800 transition duration-300 flex items-center mx-auto" data-id="element-785">
                    <Info className="h-4 w-4 mr-1" data-id="element-786" />
                    View Full Guidelines
                  </button>
                </div>
              </div>
            </div>}
        </div>
      </main>
    </div>;
};
export default MatchView;